// extracted by mini-css-extract-plugin
export default {"customer-report-container":"customer_customer-report-container__UVT+d"};